import React, { useEffect, useState } from "react";
import { FiBell, FiKey, FiFileText, FiList } from "react-icons/fi";
import { AiFillEye, AiFillEyeInvisible, AiOutlineSwap } from "react-icons/ai";
import { MdArrowForwardIos } from "react-icons/md";
import { useForm } from "react-hook-form";
import Breadcrumb, { BreadcrumbLink } from "../../../components/breadcrumbs";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import useStore from "../../../hooks/useStore";
import MinorBreadcrumb, {
  MinorBreadcrumbLink,
} from "../../../components/breadcrumbs/MinorBreadcrumb";
import { GENDERS } from "../../../utils/helpers/enums/shared.enum";
import useMinor from "../useHooks";
import useAuth from "containers/auth/useHooks";

type FormValues = {
  oldPassword: string;
  password: string;
  confirmPassword: string;
};
const MinorGeneralSettings: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();
  const { getUser } = useStore();
  const { user = null } = getUser();
  const [activeSection, setActiveSection] = useState("Privacy Policy");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [minorProfileData, setMinorProfileData] = useState<any>(null);
  const [enableNotifications, setEnableNotifications] = useState(
    Boolean(minorProfileData?.notificationEnabled)
  );
  const [termConditionContent, setTermConditionContent] = useState<[]>([]);
  const [privacyPolicyContent, setPrivacyPolicyContent] = useState<[]>([]);
  const { getPrivacyPolicy } = useAuth();

  const { getMinorProfile, toggleNotification } = useMinor();

  const getData = async () => {
    await getMinorProfile((profile: any) => {
      setMinorProfileData(profile);
      setEnableNotifications(profile?.notificationEnabled);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleToggleNotifications = async () => {
    setEnableNotifications((prev) => !prev);
    await toggleNotification();
  };

  const onSubmit = (data: FormValues) => {
    if (data.password !== data.confirmPassword) {
      alert("Passwords do not match!");
    } else {
      console.log("Password reset successfully:", data);
    }
  };

  const sidebarLinks = [
    // { id: 1, label: "Change Password", icon: <FiKey /> },
    { id: 2, label: "Notifications", icon: <FiBell /> },
    { id: 3, label: "Privacy Policy", icon: <FiFileText /> },
    { id: 4, label: "Term & Condition", icon: <FiList /> },
  ];

  const toggleNotifications = () => {
    setEnableNotifications(!enableNotifications);
  };

  const breadcrumbLinks: MinorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.minorHome },
    {
      title: "General Setting",
      path: siteRoutes.minorGeneralSettings,
    },
  ];

  useEffect(() => {
    getPrivacyPolicy(
      { heading: "Host User Agreement" },
      setTermConditionContent
    );
    getPrivacyPolicy({ heading: "Privacy Policy" }, setPrivacyPolicyContent);
  }, []);

  return (
    <div className="container">
      <MinorBreadcrumb links={breadcrumbLinks} />
      <h2 className="text-3xl text-blackie font-medium mb-4">
        General Settings
      </h2>

      <div className="flex flex-wrap sm:min-h-screen">
        {/* Sidebar */}

        <div className="w-full sm:w-[35%] md:w-1/4 bg-white">
          <ul>
            {sidebarLinks.map((link) => (
              <li
                key={link.id}
                onClick={() => {
                  if (link.label !== "Notifications") {
                    setActiveSection(link.label);
                  }
                }}
                className={`flex items-center justify-between px-3 py-4 cursor-pointer rounded-lg bordr-linear ${
                  activeSection === link.label && link.label !== "Notifications"
                    ? `${
                        user?.gender === GENDERS.MALE
                          ? "text-minorBoy"
                          : "text-minorGirl"
                      }`
                    : ""
                }`}
              >
                {/* Left Section: Icon and Label */}
                <div className="flex items-center">
                  <span
                    className={`mr-3 text-xl ${
                      activeSection === link.label &&
                      link.label !== "Notifications"
                        ? `${
                            user?.gender === GENDERS.MALE
                              ? "text-minorBoy"
                              : "text-minorGirl"
                          }`
                        : "text-primaryBlueText"
                    }`}
                  >
                    {link.icon}
                  </span>
                  <span
                    className={`${
                      activeSection === link.label &&
                      link.label !== "Notifications"
                        ? `${
                            user?.gender === GENDERS.MALE
                              ? "text-minorBoy"
                              : "text-minorGirl"
                          }`
                        : "text-primaryBlueText"
                    }`}
                  >
                    {link.label}
                  </span>
                </div>

                {/* Right Section: Arrow Icon or Notification Toggle */}
                {link.label === "Notifications" ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleNotifications();
                    }}
                    className={`w-10 h-6 flex items-center bg-gray-300 rounded-full p-1 ${
                      enableNotifications
                        ? `${
                            user?.gender === GENDERS.MALE
                              ? "bg-minorBoy"
                              : "bg-minorGirl"
                          }`
                        : "bg-gray-300"
                    }`}
                  >
                    <div
                      className={`h-4 w-4 bg-white rounded-full transform duration-300 ${
                        enableNotifications ? "translate-x-4" : ""
                      }`}
                    ></div>
                  </button>
                ) : (
                  <MdArrowForwardIos
                    className={`text-lg ${
                      activeSection === link.label
                        ? `${
                            user?.gender === GENDERS.MALE
                              ? "text-minorBoy"
                              : "text-minorGirl"
                          }`
                        : "text-gray-500"
                    }`}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Main Content */}
        <div className="flex-1 mt-5 sm:mt-0 sm:ml-6 ">
          {/* {activeSection === "Change Password" && (
            <div className="w-full md:w-2/3  flex flex-col">
          
              <div className="flex-1 flex items-center justify-center">
                <div className="w-full">
                  <div className="w-full mb-6">
                    <h1 className="text-2xl text-blackie font-semibold">
                      Change Password
                    </h1>
                    <p className="text-sm text-labelTextColor mt-2">
                      Please enter old password and confirm to continue.
                    </p>
                  </div>
                  <form onSubmit={handleSubmit(onSubmit)} className="mt-6">
                 
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center justify-between">
                        <label className="text-labelTextColor text-lg">
                          Old Password
                        </label>
                        <div
                          className="cursor-pointer flex items-center text-label"
                          onClick={() => setShowOldPassword(!showOldPassword)}
                        >
                          {showOldPassword ? (
                            <>
                              <AiFillEyeInvisible size={18} className="mr-1" />
                              <span>Hide</span>
                            </>
                          ) : (
                            <>
                              <AiFillEye size={18} className="mr-1" />
                              <span>Show</span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="w-full h-[51px] flex items-center px-3 rounded-lg border border-borderColor">
                        <input
                          type={showOldPassword ? "text" : "password"}
                          placeholder="Enter your old password"
                          {...register("oldPassword", {
                            required: "Old Password is required",
                          })}
                          className="w-full h-full px-3 outline-none"
                        />
                      </div>
                      {errors.oldPassword && (
                        <span className="text-red-500 text-sm">
                          {errors.oldPassword.message}
                        </span>
                      )}
                    </div>

              
                    <div className="flex flex-col gap-2 mt-4">
                      <div className="flex items-center justify-between">
                        <label className="text-labelTextColor text-lg">
                          New Password
                        </label>
                        <div
                          className="cursor-pointer flex items-center text-label"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <>
                              <AiFillEyeInvisible size={18} className="mr-1" />
                              <span>Hide</span>
                            </>
                          ) : (
                            <>
                              <AiFillEye size={18} className="mr-1" />
                              <span>Show</span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="w-full h-[51px] flex items-center px-3 rounded-lg border border-borderColor">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your new password"
                          {...register("password", {
                            required: "New Password is required",
                            minLength: {
                              value: 8,
                              message:
                                "Password must be at least 8 characters long",
                            },
                          })}
                          className="w-full h-full px-3 outline-none"
                        />
                      </div>
                      {errors.password && (
                        <span className="text-red-500 text-sm">
                          {errors.password.message}
                        </span>
                      )}
                    </div>

                    <div className="flex flex-col gap-2 mt-4">
                      <div className="flex items-center justify-between">
                        <label className="text-labelTextColor text-lg">
                          Confirm Password
                        </label>
                        <div
                          className="cursor-pointer flex items-center text-[#606060]"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <>
                              <AiFillEyeInvisible size={18} className="mr-1" />
                              <span>Hide</span>
                            </>
                          ) : (
                            <>
                              <AiFillEye size={18} className="mr-1" />
                              <span>Show</span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="w-full h-[51px] flex items-center px-3 rounded-lg border border-borderColor">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Confirm your new password"
                          {...register("confirmPassword", {
                            required: "Confirm Password is required",
                          })}
                          className="w-full h-full px-3 outline-none"
                        />
                      </div>
                      {errors.confirmPassword && (
                        <span className="text-red-500 text-sm">
                          {errors.confirmPassword.message}
                        </span>
                      )}
                    </div>

                    <div className="flex justify-start flex-col gap-2 pt-4">
                      <button
                        type="submit"
                        className="h-[64px]  text-xl bg-primaryBlueBg rounded-full text-white w-full sm:w-1/2"
                      >
                        Reset Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )} */}
          {activeSection === "Privacy Policy" && (
            <div>
              {privacyPolicyContent?.map((item: any) => (
                <div key={item.id} className="space-y-2">
                  <h2 className="text-2xl font-bold text-black mb-4">
                    {item.heading}
                  </h2>
                  <div
                    className="html-content text-labelTextColor text-sm"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </div>
              ))}
            </div>
          )}
          {activeSection === "Term & Condition" && (
            <div>
              {termConditionContent?.map((item: any) => (
                <div key={item.id} className="space-y-2">
                  <h2 className="text-2xl font-bold text-black mb-4">
                    {item.heading}
                  </h2>
                  <div
                    className="html-content text-labelTextColor text-sm"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MinorGeneralSettings;
